import React from 'react';

import { IndeterminateValue, isIndeterminate, PropertySelectField } from '@paragon/client-tools';
import { EnvelopeEndConnectionType } from '@paragon/contract-library';
import { humanCase } from '@paragon/utilities';

export const TrussEnvelopeEndConnectionTypeSelect = (props: {
  name: string;
  disabled?: boolean;

  connectionType: EnvelopeEndConnectionType | null | IndeterminateValue;
  submit: (connectionType: EnvelopeEndConnectionType | null) => void;
}) => {
  return (
    <PropertySelectField<EnvelopeEndConnectionType | 'Auto'>
      sx={{ margin: 0 }}
      property={props.name}
      disabled={props.disabled}
      allowUnknownValues={isIndeterminate(props.connectionType)}
      value={props.connectionType ?? 'Auto'}
      options={['Auto', 'TopChord', 'TopAndBottomChords', 'BottomChord', 'None']}
      getName={(type) => (type === 'TopAndBottomChords' ? 'Top & Bottom Chords' : humanCase(type))}
      submit={(type) => props.submit(type === 'Auto' ? null : type)}
    />
  );
};
